import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import OEBait from './components/OEBait';
import StomperTrucks from './components/StomperTrucks';
import OnJumprun from './components/OnJumprun';
import ZenCyclery from './components/ZenCyclery';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/stompertrucks" element={<StomperTrucks />} />
      <Route path="/onjumprun" element={<OnJumprun />} />
      <Route path="/zencyclery" element={<ZenCyclery />} />
      <Route path="/vistahigherlearning" element={<div className='body'><OEBait /></div>} />
    </Routes>
  </BrowserRouter>
);
reportWebVitals();
